export const arrayValidator = (promotions, length) => {
  return Array.isArray(promotions) && promotions.length > length;
};
